<template>
  <div class="campaignReportAdd">
    <div class="campaignReportAdd__header">
      <h1  class="medium-title">Create Measurement</h1>
    </div>
    <div class="campaignReportAdd__body">
      <div class="campaignReportAdd__body__left">
        <div class="campaignReportAdd__body__left__form">
          <div class="campaignReportAdd__body__left__form__container">
            <h1 class="subhead">Detail Information</h1>
            <div class="campaignReportAdd__body__left__form__container__type">
              <adx-select-dropdown :label="`Measurement Type`" :options="type" :class="['dropdown', error.measurementType ? 'warning' : '']" :value.sync="model.measurement_type"/>
              <div v-if="error.measurementType" class="error-message">{{validation.errorMessage}}</div>
            </div>
            <div class="campaignReportAdd__body__left__form__container__campaign">
              <adx-single-search-dropdown v-if="campaign.length > 0" :label="`Select Campaign`" :optionsParam="campaign" 
              :class="['dropdown', error.campaign ? 'warning' : '']" :value.sync="model.campaign"/>
              <div v-if="error.campaign" class="error-message">{{validation.errorMessage}}</div>
            </div>
          </div>
          <div class="campaignReportAdd__body__left__form__container">
            <div class="campaignReportAdd__body__left__form__container__listing">
              <h1 class="subhead">Location</h1>
              <template >
                <div v-for="(list, index) in model.listing" :key="index" class="campaignReportAdd__body__left__form__container__listing__cut">
                  <div class="top">
                    <div><adx-single-search-dropdown :label="`Select Line Item`" :optionsParam="locations" :class="['dropdown', error.locations ? 'warning' : '']" :value.sync="list.location"/></div>
                    <div class="icon-wrapper"><i @click="deleteListing(model.listing, index)" class="icon-deleted"></i></div>
                  </div>
                </div>
              </template>
              <div v-if="error.locations" class="error-message">{{validation.errorMessage}}</div>
              <div class="line-wrapper">
                <hr class="line">
              </div>
              <div class="button">
                <button @click="addListing(model.listing)" class="new">Add new</button>
              </div>
            </div>
          </div>
        </div>
      </div>  
      <div class="campaignReportAdd__body__right">
        <div class="campaignReportAdd__body__right__detail">
          <h1 class="subhead">Campaign Detail</h1>
          <div class="campaignReportAdd__body__right__detail__wrapper">
            <div class="campaignReportAdd__body__right__detail__wrapper__left">
              <span>Price</span>
              <span>Total Location</span>
            </div>
            <div class="campaignReportAdd__body__right__detail__wrapper__right">
              <p>{{ price | formatMoney }}</p>
              <p>{{ total_locations }}</p>
            </div>
          </div>
        </div>
        <div class="button-div">
          <button class="btn-large primary" 
            @click="createCampaign()">Save
          </button>
          <adx-loading-white v-if="loadingSave" class="loading-circle" />
        </div>
      </div>
    </div>
    <adx-modal v-if="showModalConfirm" :hide-close="false" title="Sure want to leave this Campaign ?" @modal-close="closeModal" type='small' :noTitle="true">
      <div class="campaignReportAdd__modal" slot="content">
          <label class="subhead">You have some unsaved changes. after leave this page you may not be able to restore your current changes. </label>
        <div class="campaignReportAdd__modal__buttons">
          <button class="btn-regular secondary" @click.stop="resetCampaign()">Leave</button>
          <button class="btn-regular primary" @click.stop="closeModal()">Stay</button>
        </div>
      </div>
    </adx-modal>
  </div>
</template>


<script>
import Input from '@/components/Form/Input'
import SelectDropdown from '@/components/Form/SelectDropdown'
import ListDropdown from '@/components/Dropdown/ListDropdown'
import Checkbox from '@/components/Form/Checkbox'
import SingleSearchDropdown from '@/components/Dropdown/SingleSearchDropdown'
import LoadingSpinner from '@/components/Loading/Secondary-white'
import Modal from '@/components/Modal'
import api from '@/api'
import { apiV2 } from '@/api/urls'
import obj2fd from 'obj2fd'

export default {
  name: 'adx-add-new-campaign',
  components: {
    'adx-input': Input,
    'adx-select-dropdown': SelectDropdown,
    'adx-dropdown-list': ListDropdown,
    'adx-checkbox': Checkbox,
    'adx-single-search-dropdown': SingleSearchDropdown,
    'adx-loading-white': LoadingSpinner,
    'adx-modal': Modal,
  },
  props: {

  },
  data() {
    return {
      isInitial: true,
      loadingSave: false,
      routeID: null,
      adx: 'Adx',
      price: 0,
      total_locations: 0,
      validation: null,
      currentCampaign: null,
      showModalConfirm: false,
      flagClose: false,
      campaignBeforeValue: null,
      listingBeforeValue: [],
      locationsBeforeValue: [],
      model: {
        campaign: null,
        location_detail: null,
        measurement_type: null,
        price: null,
        impact: false,
        listing: [
          {
            location: null
          }
        ]
      },
      locations: [],
      campaign: [],
      listing: [],
      type: [
        {
          'id': 0,
          'label': 'Digital Screen Measurement',
          'value': 'digital_screen'
        },
      ],
      error: {
        measurementType: null,
        campaign: null,
        locations: null
      },
    }
  },
  computed: {
  },
  watch: {
    'model.campaign': function (after, before) {
      if (this.flagClose == false) {
        this.campaignBeforeValue = before
        if (before != null && (this.model.listing[0].location != null || this.model.listing > 1)){
          this.showModal()
        } else {
          this.getLocationList()
        }
      } else {
        this.flagClose = false
      }
    }
  },

  beforeCreate() {

  },
  created() {
    this.getDropdownOptions();
  },
  beforeMount() {
    
  },
  mounted() {
  },
  beforeUpdate() {
  
  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    transformLocation(locations = []) {
      return locations.map(x => x.location)
    },

    getCampaignList() {
      (async () => {
        let dataCampaign = null
          const { status, data } = await api.get(apiV2.  measurementgetCampaignNameNoReport, { needToken: true })
          dataCampaign = data
        let campaign = dataCampaign.map(list => {
          return {
            label: `${list.title} ${list.owner}`,
            value: list.id
          }
        })
        this.campaign = campaign
      })();
    },

    getLocationList() {
      (async () => {
        const { data } = await api.get(apiV2.measurementGetLocations(this.model.campaign), { needToken: true })

        this.locations.length = 0
        
        data.locations.map(list => {
          this.locations.push({
            label: list.location_name,
            value: list.location_inside
          })
        })
        this.price = data.total_price,
        this.total_locations = data.count
      })();
    },

    createCampaign() {
      const data = {
        measurement_type: this.model.measurement_type,
        campaign: this.model.campaign,
        locations: this.model.listing,
        impact: this.model.impact
      }
      this.validation = this.inputValidation(data)
      if (this.validation.isValid) {
        (async () => {
          this.loadingSave = true
          data.locations = this.transformLocation(data.locations)
          const response = await api.post(apiV2.measurementCreateCampaignReport, data, { needToken: true })
          if (response.status == 201) {
            this.$notify({
              group: 'saved',
              title: 'Campaign created',
              type: 'success'
            });
            this.$router.push({ name: 'allcampaign' })
          } else {
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: response.data.error,
              type: 'warn'
            });
          }
          this.loadingSave = false
        })();
      } else {
        this.raiseError(this.validation.errorMessage)
      }
    },

    inputValidation(input) {
      let data = { isValid: true, errorMessage: null }
      let isValid = true
      this.error = {
        measurementType: null,
        campaign: null,
        locations: null
      }
      if (input.measurement_type == null) {
        data.isValid = false
        data.errorMessage = "You can't leave Measurement type empty"
        this.error.measurementType = true
        isValid = false
      } else if (input.campaign == null) {
        data.isValid = false
        data.errorMessage = "You can't leave Campaign empty"
        this.error.campaign = true
        isValid = false
      }
      if (isValid && input.locations.length > 0) {
        for (var i =0; i < input.locations.length && isValid; i++) {
          if (input.locations[i].location == null) {
            data.isValid = false
            data.errorMessage = "You can't leave Location empty"
            this.error.locations = true
            isValid = false
          }
          for (var j=i+1; j < input.locations.length; j++){
            if (input.locations[i].location == input.locations[j].location) {
              data.isValid = false
              data.errorMessage = "Location is already exists."
              this.error.locations = true
              isValid = false
            }
          }
        }
      }
      return data
    },

    raiseError(errorMessage) {
      this.$notify({
        group: 'saved',
        title: 'Error',
        text: errorMessage,
        type: 'danger'
      });
    },

    showModal() {
      this.showModalConfirm = true
    },

    closeModal() {
      this.flagClose = true
      this.showModalConfirm = false
      this.model.campaign = this.campaignBeforeValue
    },

    resetCampaign() {
      this.model.listing = [
        {
          location: null
        }
      ]
      this.showModalConfirm =  false
      this.getLocationList()
    },

    selectCut(value, purpose){
    },
    getDropdownOptions() {
      this.getCampaignList()
    },

    addListing(listing) {
      listing.push(
        {
          location: null
        }
      )
    },

    deleteListing(listing, index) {
      if (listing.length > 1) {
        listing.splice(index, 1)
      } else {
        this.$notify({
          group: 'saved',
          title: 'Delete Error',
          text: 'Oops data can not be deleted!',
          type: 'danger'
        });
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang='scss'>
@import '~@/styles/variables';
@import '~@/styles/mixins';

.campaignReportAdd {
  &__body {
    &__left {
      &__form {
        &__size {
          .selectDropdown {
            input {
              padding-top: 0;
            }
          }
        }
      }
    }
  }

  input {
    min-height: 62px;
  }

  .selectDropdown {
    .select {
      input {
        min-height: 62px;
      }
    }
  }

  .btn-regular {
    min-width: 97px;

    &.teal {
      background-color: $white;
      border: solid 1px $pale-grey;
      color: unset;
    }
  }

  .popup {
    &__input {
      &__dropdown {
        min-height: 24px;
      }
    }
  }
}
</style>
